export default __webpack_public_path__ + "static/media/icon-calendar.71c99ab5.svg";